import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-activation',
  templateUrl: './wait-activation.component.html',
  styleUrls: ['./wait-activation.component.css']
})
export class WaitActivationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
